export default "__VITE_ASSET__XyZ8C0xL__"